import { apiClient, ApiName } from '@shared/services/api'

export const fetchBankerPromoCodes = () => {
  return apiClient.get(ApiName.ADMINS, 'bankers/promoCodes')
}

export const updateBankerPromoCodes = (data) => {
  return apiClient.put(ApiName.ADMINS, 'bankers/promoCodes', data)
}

export const createBankerPromoCodes = (data) => {
  return apiClient.post(ApiName.ADMINS, 'bankers/promoCodes', data)
}

export const deleteBankerPromoCodes = (id) => {
  return apiClient.delete(ApiName.ADMINS, 'bankers/promoCodes', id)
}
